export default __webpack_public_path__ + "static/media/background.612af056.png";